module.exports = "<md-toolbar color=\"primary\">\r\n  <span>{{title}}</span>\r\n</md-toolbar>\r\n\r\n<div class=\"content\">\r\n\r\n  <app-my-feeds></app-my-feeds>\r\n\r\n  <app-control-push></app-control-push>\r\n\r\n  <app-post-tweet></app-post-tweet>\r\n\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 158
// module chunks = 1